import './contact.sass'

const Contact = () => {
    async function sendForm(){
        try {
            
        } catch (err) {
            
        }
    }
    return (
        <div className='contact' id='contact'>
            <div className='contact__rod'></div>
            <div className='contact__container'>
                <div className='contact__container__addr'>
                    <div className='contact__container__addr__content'>
                        <h2 className='contact__container__addr__content__title'>Contact</h2>
                        <p className='contact__container__addr__content__para'><strong>SCS Informatique</strong></p>
                        <p className='contact__container__addr__content__para'>250 Rue des Tamagnards, ZAE les Geymonds</p>
                        <p className='contact__container__addr__content__para'>38250 Villard de lans, France</p>
                        <p className='contact__container__addr__content__para'>info@scsinformatique.com</p>
                        <p className='contact__container__addr__content__para'>Tél : 04 76 94 08 75</p>
                        <p className='contact__container__addr__content__para'>Pour les urgences : 06 72 41 99 80</p>
                    </div>
                    <div className='contact__container__addr__content'>
                        <h2 className='contact__container__addr__content__title'>Horaires</h2>
                        <p className='contact__container__addr__content__para'>Mardi - Vendredi : 09h-12h et 14h-18h</p>
                        <p className='contact__container__addr__content__para'>Vendredi : 09h-16h</p>
                        <p className='contact__container__addr__content__para'>Samedi / Dimanche / Lundi : Fermé</p>
                    </div>
                </div>
                {/* <form onSubmit={sendForm} className='contact__container__form'>
                    <div className='contact__container__form__identity'>
                        <div className='contact__container__form__identity__info'>
                            <label htmlFor='nom'>Nom</label>
                            <input className='contact__container__form__input' name='nom' id='nom' aria-label='champ du nom' type='text'/>
                        </div>
                        <div className='contact__container__form__identity__info'>
                            <label htmlFor='prenom'>Prénom</label>
                            <input className='contact__container__form__input' name='prenom' id='prenom' aria-label='champ du prénom' type='text'/>
                        </div>
                    </div>
                    <label htmlFor='mail'>E-mail*</label>
                    <input className='contact__container__form__input' name='mail' id='mail' aria-label='champ du mail' type='text'/>
                    <label htmlFor='message'>Laissez-nous un message...</label>
                    <textarea className='contact__container__form__input' name='message' id='message' aria-label='champ du message' type='text' rows={7}/>
                    <button className='contact__container__form__btn' type='submit'>Envoyer</button>
                </form> */}
            </div>
            
            <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d981.1434507256702!2d5.556661802068722!3d45.08801650402183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478a917f01f1e225%3A0x16c623a8e347fd93!2sS.C.S%20Informatique!5e1!3m2!1sfr!2sfr!4v1714054993238!5m2!1sfr!2sfr' width='100%' height='450' style={{border:'0'}} allowFullScreen='' loading='lazy' referrerPolicy='no-referrer-when-downgrade'></iframe>
        </div>
    )
}

export default Contact